import { Badge, Button, makeStyles } from '@material-ui/core';

const useTabStyles = makeStyles((theme) => ({
  button: (props: { isActive: boolean }) => ({
    padding: '5px 10px',
    backgroundColor: props.isActive ? theme.palette.admin.primary.main : 'transparent',
    color: props.isActive ? theme.palette.admin.primary.contrastText : 'inherit',

    '&:hover': {
      backgroundColor: props.isActive ? theme.palette.admin.primary.main : 'inherit',
      color: props.isActive ? theme.palette.admin.primary.contrastText : 'inherit',
    },
  }),

  badgeRoot: {
    alignItems: 'center',
  },

  badgeInline: {
    position: 'static',
    transform: 'none',
    marginLeft: '0.5rem',
  },
}));

type Props = {
  size?: 'small' | 'medium';
  disabled?: boolean;
  label: string;
  isActive: boolean;
  value: string;
  count?: number;
  onClick: (tabValue: string) => void;
};

export default function ButtonTab({ size = 'medium', disabled, label, isActive, value, count, onClick }: Props) {
  const classes = useTabStyles({ isActive });

  const handleClick = () => onClick(value);

  return (
    <Button size={size} className={classes.button} onClick={handleClick} disabled={disabled}>
      {count !== undefined ? (
        <Badge badgeContent={count} showZero classes={{ root: classes.badgeRoot, badge: classes.badgeInline }}>
          {label}
        </Badge>
      ) : (
        label
      )}
    </Button>
  );
}
